import { generateUrlParams } from "../../utils/generateUrlParams";

const baseUrl = "PostUtme";

export const putmeLoadApplicationFormUrl = (jambRegNumber) =>
	`${baseUrl}/load-application-form?regNumber=${jambRegNumber}`;

export const putmePersonalDetailsFormUrl = () =>
	`${baseUrl}/add-or-update-putme-application-personal-details`;

export const putmeCertificateDetailsFormUrl = () =>
	`${baseUrl}/add-or-update-putme-application-certificate-details`;

export const putmeOLevelDetailsFormUrl = () =>
	`${baseUrl}/add-or-update-putme-application-olevel-details`;

export const putmeProgrammeDetailsFormUrl = () =>
	`${baseUrl}/add-or-update-putme-application-programme-details`;

export const getPutmeApplicationReportsUrl = (filter) =>
	`${baseUrl}/post-utme-applications-report?${generateUrlParams(filter)}`;

export const downloadPutmeApplicationReportsUrl = (filter) =>
	`${baseUrl}/download-utme-applications-report?${generateUrlParams(filter)}`;

export const getStudentAdmissionReportsUrl = (filter) =>
	`${baseUrl}/get-student-admission-report?${generateUrlParams(filter)}`;

export const downloadStudentAdmissionReportsUrl = (filter) =>
	`${baseUrl}/download-student-admission-report?${generateUrlParams(filter)}`;

export const getPutmeRankingReportsUrl = (filter) =>
	`${baseUrl}/get-post-utme-ranking-report?${generateUrlParams(filter)}`;
export const downloadPutmeRankingReportsUrl = (filter) =>
	`${baseUrl}/download-post-utme-ranking-report?${generateUrlParams(filter)}`;
export const downloadPutmeRankingReportsTemplateUrl = () =>
	`${baseUrl}/download-post-utme-olevel-results-template`;
export const getTotalPutmeResultsUrl = () =>
	`${baseUrl}/total-post-utme-results`;
export const uploadPutmeOLevelResultsUrl = () =>
	`${baseUrl}/upload-post-utme-olevel-results`;
export const getPostUtmeResultUrl = (jambRegNumber) =>
	`${baseUrl}/get-post-utme-result?jambRegNumber=${jambRegNumber}`;
